import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/mail_gray_60.png'


const _withScopeId = n => (_pushScopeId("data-v-68b710aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { computed } from 'vue';
import { useFamilyGroupInviteStore } from '@/gp/FamilyGroupInviteStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useUserStore } from '@/gp/UserStore'
import CompactItem from '@/util/CompactItem.vue'
import { LoadMode } from '@/util/AsyncData'
    
  
export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupInviteItem',
  props: {
    inviteId: String,
    selectMode: Boolean,
  },
  emits: [
    'click'
],
  setup(__props, { emit }) {

const props = __props;



  
  
const inviteStore = useFamilyGroupInviteStore()
const familyGroupStore = useFamilyGroupStore()
const userStore = useUserStore()

const inviteRef = computed(() => inviteStore.getAsyncInvite(props.inviteId, LoadMode.EnsureLoaded)?.data)
const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(inviteRef.value?.familyGroupId)?.data) // loaded with invite
const senderUserRef = computed(() => userStore.getAsyncUser(inviteRef.value?.senderUserId)?.data) // loaded with invite


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CompactItem, {
    class: "family-group-invite-item",
    "select-mode": "",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', props.inviteId)))
  }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _createTextVNode("Invitation to join " + _toDisplayString(familyGroupRef.value?.name) + " group", 1)
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode("Sent by " + _toDisplayString(senderUserRef.value?.displayName), 1)
    ]),
    _: 1
  }))
}
}

})